// extracted by css-extract-rspack-plugin
export default {"radioInput":"radioInput-3kQ4B","label":"label-1_TFg","labelText":"labelText-19Nby"};